import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import * as yup from 'yup';
import { Schema } from 'yup';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { HeaderSubTitle } from 'src/modules/dashboard/components/atoms/headerSubTitle';
import { createEventParticipant } from 'src/shared/services/eventParticipantService';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { EventParticipantRequest } from '../models/eventParticipantRequest';

type EventSignUpFormProps = {
  eventId: number;
};

// Denna kommer inte användas i och med Evenemang 2.0
const EventSignUpForm = (props: EventSignUpFormProps) => {
  const { eventId } = props;
  const { t } = useTranslation(['common', 'event']);
  const isMounted = useIsMounted();
  const requiredMessage = t('common:validationMessages.required');

  const [loading, setLoading] = useState(false);

  const EventFormRequestPostSchema: Schema<EventParticipantRequest> = yup.object().shape({
    event_id: yup.number().required(),
    member_id: yup.number().required(),
    firstName: yup.string().required(requiredMessage),
    lastName: yup.string().required(requiredMessage),
    email: yup.string().email().required(requiredMessage),
    phone: yup.string().required(requiredMessage),
  });

  const formMethods = useForm({
    resolver: yupResolver(EventFormRequestPostSchema),
    defaultValues: {
      event_id: eventId,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
  });
  const { handleSubmit } = formMethods;

  const onSubmit = async (data: EventParticipantRequest) => {
    setLoading(true);
    try {
      const res = await createEventParticipant(data);
      if (isMounted()) {
        ConsoleHelper.log('RES:: ', res.data);
      }
    } catch (error) {
      if (isMounted()) {
        ConsoleHelper.log(error);
      }
    } finally {
      if (isMounted()) {
        setLoading(false);
      }
    }
  };
  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <GridWrapper>
            <Grid item xs={12}>
              <HeaderSubTitle label={t('event:signupHeader')} />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='firstName'
                required
                label={t('event:formFields.firstName')}
                inputProps={{ maxLength: 50 }} // TODO
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='lastName'
                required
                label={t('event:formFields.lastName')}
                inputProps={{ maxLength: 50 }} // TODO
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='email'
                required
                label={t('event:formFields.email')}
                inputProps={{ maxLength: 50 }} // TODO
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <ControlledTextField
                name='phone'
                required
                label={t('event:formFields.phoneNumber')}
                inputProps={{ maxLength: 50 }} // TODO
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button size='large' variant='contained' fullWidth color='success' type='submit' disableElevation disabled={loading}>
                {t('event:signup')}
              </Button>
            </Grid>
          </GridWrapper>
        </form>
      </FormProvider>
    </>
  );
};

export default EventSignUpForm;
